module.exports = __webpack_public_path__ + "img/yxlogo_black1.5932ff61.png";